module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMBAMAAACkW0HUAAAAFVBMVEWZmZn///+ZmZmZmZmZmZmZmZmZmZlqNPAWAAAABnRSTlMAACDA3+D5kQVHAAAAK0lEQVQI12MQBAMGVAoKmNzS0tKCGBhU0tJSFcDcIJCwCogD5BoxoAOIdgA38Aa3E1KWlQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/select-arrow.png
// module id = 466
// module chunks = 0